module.exports = __webpack_public_path__ + "static/media/home-cdm-image.e1b65759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-cdm-image.png
// module id = 219
// module chunks = 0